import { ApiGetRequest, ICounterParty } from 'types';

export enum ERampType {
  BUY = 'buy',
  SELL = 'sell',
}

export enum EWalletPinAction {
  UPDATE = 'update',
  RESTORE = 'restore',
}

export enum EWalletNetwork {
  POLYGON = 'MATIC',
  POLYGON_TEST = 'MATIC-AMOY',
  BASE = 'BASE',
  BASE_TEST = 'BASE-SEPOLIA',
}

export enum EWalletTransactionType {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
}

export enum EWalletModals {
  RAMP = 'ramp',
  CONFIRM = 'confirm',
}

export enum EWalletModalModalAction {
  DISABLE_WALLET = 'disable_wallet',
  ENABLE_WALLET = 'enable_wallet',
}

export interface EWalletModalPayload {
  action?: EWalletModalModalAction;
}

export interface IWalletModal {
  type: EWalletModals;
  rampType?: ERampType;
  payload?: EWalletModalPayload;
}

interface IWalletNetwork {
  name: string;
  explorerUrl: string;
}

export const WalletNetworkMap: Record<EWalletNetwork, IWalletNetwork> = {
  [EWalletNetwork.POLYGON]: {
    name: 'Polygon',
    explorerUrl: 'https://polygonscan.com/tx/',
  },
  [EWalletNetwork.POLYGON_TEST]: {
    name: 'Polygon TestNet',
    explorerUrl: 'https://amoy.polygonscan.com/tx/',
  },
  [EWalletNetwork.BASE]: {
    name: 'Base',
    explorerUrl: 'https://basescan.org/tx/',
  },
  [EWalletNetwork.BASE_TEST]: {
    name: 'Base TestNet',
    explorerUrl: 'https://sepolia.basescan.org/tx/',
  },
};

export interface IWalletTransaction {
  id: string;
  necs_transaction_id: string;
  counter_party?: ICounterParty;
  transaction_hash: string;
  amount: string;
  destination_address: string;
  source_address: string;
  blockchain: EWalletNetwork;
  type: EWalletTransactionType;
  date: string;
}

export interface IWallet {
  id: number;
  wallet_id: string;
  address: string;
  balance: string;
  blockchain: EWalletNetwork;
  currency: string;
  qr_code: string;
  change: number;
  is_deployed: boolean;
  is_active: boolean;
  pending_transactions: string[] | number[];
}

export interface IWalletChallenge {
  challengeId: string;
  userToken: string;
  encryptionKey: string;
}

export interface FetchWalletTransactionsPayload extends ApiGetRequest {
  filter_by_creation_start_date?: string | null;
  filter_by_creation_end_date?: string | null;
  filter_by_type?: string | null;
}

export interface WalletTransferPayload {
  destination_address: string;
  amount: number;
}

export interface WalletPayload {
  id: number;
}

export interface WalletStatePayload extends WalletPayload {
  is_active: boolean;
}
export interface ValidateAddressPayload {
  address: string;
  blockchain: string;
}

export interface ValidateAddressResponse {
  is_valid: boolean;
}

export interface SignMessagePayload extends WalletPayload {
  message: string;
}

export interface WalletPinPayload {
  action: EWalletPinAction;
}

export interface MTPConfig {
  _ctkn: string;
  _ngm?: 0 | 1;
  type?: 'popup' | 'web' | 'webview';
  lang?: 'en' | 'de' | 'fr';
  mode?: 'dark';
  tab?: 'buy' | 'sell' | 'swap';
  tabs?: string;
  net?: 'base_mainnet';
  nets?: string;
  curs?: string; //List of authorized fiat currencies 'NOK' | 'EUR' | 'USD' | 'GBP'
  bda?: number; //Buy tab destination amount
  bsc?: 'EUR'; //Buy tab source currency
  bdc?: 'EURC'; //Buy tab destination currency
  dnet?: 'base_mainnet'; //Destination network
  ssc?: 'EURC'; //Sell tab source currency
  ssa?: number; //Sell tab source amount
  snet?: 'base_mainnet'; //Source network
  sdc?: 'EUR'; //Sell tab destination currency
  crys?: 'EURC'; //List of authorized cryptocurrencies
  //Address validation
  addr?: string;
  code?: string;
  chain?: 'base_mainnet';
  hash?: string;
}
